<div *ngIf="!order && !orderNotFound" class="mt-2 mb-5">
    <h5 align="center" class="tar-name-preload">Obteniendo orden...</h5>

    <div align="center">
        <img class="" src="./assets/img/spinner.svg" width="30" alt="">
    </div>
</div>

<div *ngIf="order">
    <div class="content mb-2">
        <div class="row">
            <div class="col-md-12">
                <h5 class="title-step mt-4" align="center">
                    <img src="./assets/img/file-text2.svg" class="img-fluid ico-title" width="20">
                    Resumen de la activación
                </h5>

                <div class="alert {{ getAlertClass(order.super_status) }}" role="alert" *ngIf="from == 'form' || +order.super_status === superStatus.in_process">
                    <div class="row align-items-center">
                        <div class="col">
                            <h4 class="alert-heading mt-2">
                                <div class="{{ order.super_status === superStatus.cancelled ? 'ic-order-cancel' : 'checkmark-white' }}"></div>
                                <b>{{ getAlertTitle(order.super_status) }}</b>
                            </h4>
                            <p>{{ getAlertDescription(order) }}</p>
                        </div>

                        <div class="col-auto" *ngIf="+order.status.code >= 0 && +order.status.code < 3">
                            <button class="btn btn-black btn-sm" type="button" (click)="reloadPage()">Comprobar de nuevo</button>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>

    <div class="mt-3">
        <div class="row">
            <div class="col-md-12">
                <div class="jumbotron-norm-r mb-3">
                    <div class="row ms-1">
                        <div class="col-lg-2"><h5 align="left" class="tar-name-6 mt-2 mb-1">Nº de contrato</h5>
                            <h5 align="left" class="tar-name-7 mt-1">{{ getContractNumber(order) }}</h5>
                        </div>

                        <div class="col-lg-2">
                            <h5 align="left" class="tar-name-6 mt-2 mb-1">Fecha</h5>
                            <h5 align="left" class="tar-name-7 mt-1">{{ order.created_at | date: 'dd/MM/yyyy HH:mm' }}</h5>
                        </div>

                        <div class="col-lg-2">
                            <h5 align="left" class="tar-name-6 mt-2 mb-1">Estado</h5>
                            <h5 align="left" class="tar-name-7 mt-1 complete">{{ order.status_description }}</h5>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="mt-2">
        <div class="row">
            <div class="col-md-12">
                <div class="card mb-3">
                    <div class="card-header">
                        <div class="d-flex justify-content-between align-items-center">
                            <div>
                                <h6 class="subtitulo-pack2">
                                    <b>Cliente</b>
                                </h6>
                            </div>
                        </div>
                    </div>

                    <div class="card-body bg-white">
                        <div class="row mt-4">
                            <div class="col-lg-8">
                                <!-- Nombre cliente -->
                                <h5 class="title-list ms-3">
                                    <span class="text-list">
                                        <b>{{ order.customer_full_name }}</b>
                                    </span>
                                    <br><br>
                                    <!-- Documento de identidad -->
                                    <span class="font-list" *ngIf="order && order.customer_document && order.customer_document !== ''">
                                        <img src="./assets/img/file.svg" class="img-fluid" width="13">
                                        {{ order?.customer_document_type?.digo_code}}: <b>{{ order.customer_document }}</b>
                                    </span>
                                    <br>
                                    <!-- Fecha de solicitud -->
                                    <span class="font-list">
                                        <img src="./assets/img/clock.svg" class="img-fluid" width="13">
                                        Fecha de solicitud: <b>{{ order.created_at | date: 'dd/MM/yyyy, HH:mm' }}</b>
                                    </span>
                                    <br>
                                    <!-- Tipo de alta -->
                                    <span class="font-list">
                                        <img src="./assets/img/package2.svg" class="img-fluid" width="13">
                                        Tipo de alta: <b>{{ order.type == 'convergent' || order.type === 'broadband' ? 'Fijo y Móvil' : 'Móvil' }}</b>
                                        <b class="info-secundaria" *ngIf="order.mobiles && order.mobiles.length > 1">
                                            + {{ order.mobiles.length - 1 }} línea(s) adicional(es)
                                        </b>
                                    </span>
                                    <!-- Número fijo -->
                                    <span class="font-list" *ngIf="order.broadband && order.broadband.msisdn && order.broadband.msisdn !== ''">
                                        <br>
                                        <img src="./assets/img/phone.svg" class="img-fluid" width="13">
                                        Teléfono fijo: <b>{{ order.broadband.msisdn }}</b>
                                    </span>
                                    <!-- MSISDN -->
                                    <span class="font-list" *ngIf="order.mobiles && order.mobiles.length > 0 && order.mobiles[0].msisdn != ''">
                                        <br>
                                        <img src="./assets/img/phone.svg" class="img-fluid" width="13">
                                        Móvil Amena principal: <b>{{ order.mobiles[0].msisdn }}</b>
                                  </span>
                                </h5>
                            </div>
                            <div align="right" class="col-lg-4">
                                <div class="mb-2" *ngIf="order.mobiles && order.mobiles.length > 0">
                                    <span class="badge badge-pill badge-success font-list">
                                        <span>
                                            {{ order.mobiles[0]?.rate?.name }}: {{ order.mobiles[0].rate?.price }} €
                                        </span>
                                    </span>
                                </div>
                            </div>
                            <!-- Comentarios -->
                            <div class="col-xl-7">
                                <mat-form-field class="form-list px-3">
                                    <mat-label>Observaciones</mat-label>
                                    <textarea #observations id="observations" matInput oninvalid="" required [disabled]="updatingAnnotations">{{ order.annotation }}</textarea>
                                </mat-form-field>

                                <button type="button" class="btn btn-black btn-sm mt-3 mx-3" (click)="updateAnnotation(order, observations.value)">
                                    <span *ngIf="updatingAnnotations" class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
                                    {{ updatingAnnotations ? 'Guardando...' : 'Guardar observaciones' }}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!--------- Resumen de la contratación ------------>
    <!------------------------------------------------->

    <div class="mt-2">
        <div class="row">
            <div class="col-md-12">

                <div class="accordion" id="accordionExample">
                    <div class="card">
                        <div class="card-header" id="headingOne">
                            <div class="d-flex justify-content-between align-items-center">
                                <div class="ms-3">
                                    <b>Resumen de la tramitación</b>
                                </div>
                            </div>
                            <h2 class="mb-0"></h2>
                        </div>

                        <div class="card-body bg-white">
                            <div *ngFor="let mobile of order.mobiles; index as itemIndex">
                                <!-- RESUMEN MOVIL PACK -->
                                <h5 align="left" class="tar-name-7 mt-2 ms-3">
                                    <b *ngIf="order.type == 'convergent'">{{ itemIndex === 0 ? 'Fijo y móvil' : 'Linea móvil adicional' }}</b>
                                    <b *ngIf="order.type == 'mobile'">{{ itemIndex === 0 ? 'Móvil principal' : 'Linea móvil adicional' }}</b>
                                </h5>

                                <div class="resumen d-flex justify-content-between align-items-center">
                                    <span class="sidebar-info4 verde">Conceptos</span>
                                </div>

                                <div class="resumen d-flex justify-content-between align-items-center">
                                    <!-- tarifa -->
                                    <span class="sidebar-info5">
                                        <img src="./assets/img/package2.svg" class="img-fluid" width="13">
                                        {{ mobile.rate.name }}
                                    </span>
                                    <small class="text-muted">
                                        <!-- Precio tarifa -->
                                        <span class="sidebar-info3"><b>{{ mobile.rate.price }} €/mes</b></span>
                                    </small>
                                </div>

                                <div class="resumen d-flex justify-content-between align-items-center" *ngIf="mobile.rate.increase">
                                    <!-- tarifa -->
                                    <span class="sidebar-info5">
                                        <img src="./assets/img/package2.svg" class="img-fluid" width="13">
                                        Incremento fibra indirecta
                                    </span>
                                    <small class="text-muted">
                                        <!-- Precio tarifa -->
                                        <span class="sidebar-info3"><b>{{ mobile.rate.increase }} €/mes</b></span>
                                    </small>
                                </div>

                                <div class="resumen d-flex justify-content-between align-items-center" *ngIf="mobile.terminal">
                                    <!-- Terminal-->
                                    <span class="sidebar-info5">
                                        <img src="./assets/img/smartphone2.svg" class="img-fluid" width="13">
                                        {{ mobile.terminal.brand }} {{ mobile.terminal.name }} ({{ mobile.terminal_vap ? mobile.terminal.payment_months + ' meses' : 'Pago inicial.' }})
                                    </span>
                                    <small class="text-muted">
                                        <!-- Precio terminal -->
                                        <span class="sidebar-info3"><b>{{ mobile.terminal_vap ? mobile.terminal.payment_quota + ' €/mes' : '' }}</b></span>
                                    </small>
                                </div>

                                <div class="resumen pt-0 d-flex flex-column align-items-start"
                                        *ngIf="!mobile.order_amena && mobile.order_amena.amena_contract_number">
                                    <span class="ms-3 d-block">
                                        <small>Contrato: <strong>{{ mobile.order_amena.amena_contract_number }}</strong></small>
                                    </span>
                                </div>

                                <div class="resumen pt-0 d-flex flex-column align-items-start"
                                        *ngIf="order.type === 'convergent' && order.broadband && itemIndex === 0">
                                    <span class="ms-3 d-block" *ngIf="!order.broadband.portability && order.broadband.new_msisdn">
                                        <small>Número Amena Fijo: <strong>{{ order.broadband.new_msisdn }}</strong></small>
                                    </span>

                                    <span class="ms-3 d-block" *ngIf="order.broadband.portability && order.broadband.msisdn != ''">
                                        <small>Número Portabilidad Fijo: <strong>{{ order.broadband.msisdn }}</strong></small>
                                    </span>

                                    <span class="ms-3 d-block" *ngIf="order.broadband.portability && order.broadband.service_provider">
                                        <small>Portabilidad fijo desde: <strong>{{ order.broadband.service_provider.name }}</strong></small>
                                        <!--<small>Portabilidad desde: <strong>{{ mobile.service_provider.name }}</strong></small>-->
                                    </span>
                                </div>

                                <div class="resumen pt-0 d-flex flex-column align-items-start">
                                    <span class="ms-3 d-block" *ngIf="!mobile.portability && mobile.new_msisdn">
                                        <small>Número Amena Móvil: <strong>{{ mobile.new_msisdn }}</strong></small>
                                    </span>

                                    <span class="ms-3 d-block" *ngIf="mobile.portability && mobile.msisdn != ''">
                                        <small>Número Portabilidad Móvil: <strong>{{ mobile.msisdn }}</strong></small>
                                    </span>

                                    <span class="ms-3 d-block" *ngIf="mobile.portability && mobile.service_provider">
                                        <small>Portabilidad móvil desde: <strong>{{ mobile.service_provider.name }}</strong></small>
                                    </span>
                                </div>
                                <br>

                                <div class="resumen d-flex justify-content-between align-items-center mt-2">
                                    <span class="sidebar-info">
                                        <b>Total</b>
                                    </span>
                                    <small class="text-muted trash-carrito">
                                        <!-- Precio tarifa -->
                                        <span class="sidebar-info2">
                                            <b>{{ getTerminalMonthlyPrice(mobile).toFixed(2) }} €/mes</b>
                                        </span>
                                    </small>
                                </div>
                                <hr>
                            </div>

                            <div class="resumen d-flex justify-content-between align-items-center" *ngIf="order.type !== 'mobile' && getTotalDiscount(order.mobiles) > 0">
                                <span class="sidebar-info">Descuento <b>líneas adicionales</b></span>
                                <small class="text-muted trash-carrito">
                                    <span class="sidebar-info2">
                                        <b>-{{ getTotalDiscount(order.mobiles).toFixed(2) }} €/mes</b>
                                    </span>
                                </small>
                            </div>

                            <!-- Importe Total -->
                            <div class="resumen-total total d-flex justify-content-between align-items-center" *ngIf="getTotalMonthlyPrice(order.mobiles) > 0">
                                <h5 class="total-color">
                                    <b>Pago mensual</b>
                                </h5>
                                <h5 class="text-auto" *ngIf="order.type === 'mobile'">
                                    <b>{{ getTotalMonthlyPrice(order.mobiles).toFixed(2) }} €/mes</b>
                                </h5>
                                <h5 class="text-auto" *ngIf="order.type !== 'mobile'">
                                    <b>{{ getTotalMonthlyPriceWithDiscount(order.mobiles).toFixed(2) }} €/mes</b>
                                </h5>
                            </div>

                            <br *ngIf="getTerminalsWithInitialPayment(order.mobiles).length > 0 || terminalDelivery">
                            <hr *ngIf="getTerminalsWithInitialPayment(order.mobiles).length > 0 || terminalDelivery">

                            <div class="mb-1" *ngFor="let mobile of getTerminalsWithInitialPayment(order.mobiles)">
                                <div class="resumen d-flex justify-content-between align-items-center">
                                    <span class="sidebar-info">
                                        <img src="./assets/img/smartphone2.svg" class="img-fluid" width="13">
                                        {{ mobile.terminal.brand }} {{ mobile.terminal.name }} ({{ mobile.terminal_vap ? 'Cuota inicial' : 'Pago anticipado' }})
                                    </span>
                                    <small class="text-muted trash-carrito">
                                        <span class="sidebar-info2">
                                            <b>{{ getTerminalInitialPrice(mobile).toFixed(2) }} €</b>
                                        </span>
                                    </small>
                                </div>
                            </div>

                            <div class="mb-1" *ngIf="terminalDelivery">
                                <div class="resumen d-flex justify-content-between align-items-center">
                                    <span class="sidebar-info">
                                        <img src="./assets/img/layers.svg" class="img-fluid" width="13">
                                        {{ terminalDeliveryTitle }}
                                    </span>
                                    <small class="text-muted trash-carrito">
                                        <span class="sidebar-info2">
                                            <b>{{ terminalDelivery.deliveryPrice.toFixed(2) }} € {{ numLogis > 1 ? (' x ' + numLogis + '*') : '' }}</b>
                                        </span>
                                    </small>
                                </div>
                            </div>

                            <div class="mb-1" *ngIf="terminalDelivery && numLogis > 1">
                                <div class="resumen d-flex justify-content-between align-items-center">
                                    <span class="sidebar-info">
                                        *Líneas con envío por logística
                                    </span>
                                </div>
                            </div>

                            <div class="resumen-total total d-flex justify-content-between align-items-center" *ngIf="getTotalInitialPrice(order.mobiles) > 0">
                                <h5 class="total-color">
                                    <b>Pago inicial</b>
                                </h5>
                                <h5 class="text-auto">
                                    <b>{{ getTotalInitialPrice(order.mobiles).toFixed(2) }} €/mes</b>
                                </h5>
                            </div>
                            <div class="info-nav-sidebar" *ngIf="cartAgreements && cartAgreements !== '' && cartAgreements.show">
                                <span class="sidebar-info">
                                    <b>Importes a añadir en tu última factura Orange:</b>
                                </span>
                                <br>
                                <li class="sidebar-info mt-0" *ngIf="cartAgreements.cp_price > 0">
                                    {{ cartAgreements.cp_price }} € por penalización CP línea móvil
                                </li>
                                <br *ngIf="cartAgreements.cp_price > 0">
                                <li class="sidebar-info mt-0" *ngIf="cartAgreements.terminals && cartAgreements.terminals.length">
                                    {{ cartAgreements.vap_price }} € en cuotas del terminal pendientes
                                </li>            
                            </div>
                            <ng-template [ngIf]="(getTotalInitialPrice(order.mobiles) > 0) || ( getTotalMonthlyPrice(order.mobiles) > 0)" [ngIfElse]="emptyData">
                                <div class="resumen-total total d-flex justify-content-between align-items-center">
                                    <span class="total-color">
                                        <b>IVA incluido</b>
                                    </span>
                                </div>
                            </ng-template>
                            <ng-template #emptyData>
                                <div class="container">
                                    <b>Este pedido no contiene datos sobre los servicios a contratar.</b>
                                </div>
                            </ng-template>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!--------- Documentación para firmar ------------>
    <!------------------------------------------------>

    <div class="firma mt-4 mb-5">
        <div class="row">
            <div class="col-md-12">
                <div class="row">
                    <div class="col-lg-6" *ngIf="hasDocs()">
                        <div class="card">
                            <div class="card-header">
                                <div class="d-flex justify-content-between align-items-center">
                                    <div>
                                        <h6 class="subtitulo-pack2 ms-3">
                                            <b>Descarga de contratos</b>
                                        </h6>
                                    </div>

                                    <small class="text-muted">
                                        <div class="{{ getNumberOfPendingDocuments(order.mobiles) == 0 ? 'checkmark' : 'checkmark-disabled' }}"></div>
                                    </small>
                                </div>
                            </div>
                            <ul class="list-group list-group-flush">
                                <li class="list-group-item cuerpo-pack-2">
                                    <h5 align="left" class="tar-name-7 mt-2 ms-3">
                                        Hay <b>{{ getDocumentsDescription(order.mobiles) }}</b>
                                    </h5>

                                    <div class="d-flex" *ngFor="let mobile of order.mobiles; index as indexItem">
                                        <a (click)="downloadDocument(mobile.order_amena.amena_order_id, order.type == 'convergent' && indexItem == 0 ? (order.broadband.portability ? order.broadband.msisdn : order.broadband.new_msisdn) : (mobile.portability ? mobile.msisdn : mobile.new_msisdn))" target="_blank" class="tar-name-8 mt-1 ms-3 btn"
                                           *ngIf="mobile.order_amena && mobile.order_amena.amena_order_id && mobile.has_docs">
                                            <img src="./assets/img/file.svg" class="img-fluid ico-title" width="13">
                                            Contrato
                                            <span *ngIf="order.type == 'convergent' && indexItem === 0">
                                                <span *ngIf="!order.broadband.portability">{{ order.broadband.new_msisdn }}</span>
                                                <span *ngIf="order.broadband.portability">{{ order.broadband.msisdn }}</span>
                                            </span>

                                            <span *ngIf="order.type == 'mobile' || indexItem > 0">
                                                <span *ngIf="!mobile.portability">{{ mobile.new_msisdn }}</span>
                                                <span *ngIf="mobile.portability">{{ mobile.msisdn }}</span>
                                            </span>
                                        </a>
                                    </div>
                                </li>
                                <li class="list-group-item cuerpo-pack-2">
                                    <h5 align="left" class="tar-name-7 mt-2 ms-3">
                                        <b>Documento de privacidad</b>
                                    </h5>

                                    <div class="d-flex" *ngFor="let mobile of order.mobiles; index as indexItem">
                                        <a (click)="downloadDocumentPrivacy(mobile.order_amena.amena_order_id, order.type == 'convergent' && indexItem == 0 ? (order.broadband.portability ? order.broadband.msisdn : order.broadband.new_msisdn) : (mobile.portability ? mobile.msisdn : mobile.new_msisdn))" target="_blank" class="tar-name-8 mt-1 ms-3 btn"
                                           *ngIf="mobile.order_amena && mobile.order_amena.amena_order_id && mobile.has_docs">
                                            <img src="./assets/img/file.svg" class="img-fluid ico-title" width="13">
                                            Documento
                                            <span *ngIf="order.type == 'convergent' && indexItem === 0">
                                                <span *ngIf="!order.broadband.portability">{{ order.broadband.new_msisdn }}</span>
                                                <span *ngIf="order.broadband.portability">{{ order.broadband.msisdn }}</span>
                                            </span>

                                            <span *ngIf="order.type == 'mobile' || indexItem > 0">
                                                <span *ngIf="!mobile.portability">{{ mobile.new_msisdn }}</span>
                                                <span *ngIf="mobile.portability">{{ mobile.msisdn }}</span>
                                            </span>
                                        </a>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>

                    <div class="col-md-12 pb-3">
                        <div align="center" class="mt-5 mt-2 mb-2">
                            <button class="btn btn-green btn-sm w-100" (click)="continueProcess(order)" *ngIf="order.super_status === superStatus.draft" [disabled]="disabledButton">
                                Continuar la tramitación donde la había dejado
                            </button>
                            <button class="btn btn-green btn-sm w-100" (click)="openModal(content)" *ngIf="order.super_status !== superStatus.draft" [disabled]="disabledButton">
                                Realizar nueva tramitación copiando los datos de este cliente
                            </button>
                            <button class="btn btn-green btn-sm w-100 mt-2" (click)="removeDraft()" *ngIf="order.super_status === superStatus.draft" [disabled]="disabledButton">
                                Eliminar borrador
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="container mt-3" *ngIf="orderNotFound">    
    <div class="row">
        <div class="col-md-12">
            <h5 class="title-step mt-4" align="center">
                Lo sentimos, el pedido que está buscando no existe
            </h5>
            <div align="center">
                <button routerLink="/amena/listado" class="btn btn-green btn-sm mt-2">
                    Volver al listado
                </button>
            </div>
        </div>
    </div>
</div>

<ng-template #content let-modal>
    <div class="modal-header">
        <h5 class="modal-title white" id="exampleModalLabel">Tipo de tramitación</h5>

        <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="modal.dismiss()">
            <span aria-hidden="true">
                <img src="./assets/img/times2.svg" class="img-fluid ico-title" width="20">
            </span>
        </button>
    </div>

    <div class="modal-body">
        <div class="row" style="justify-content: center;">
            <div class="col-lg-6" *ngIf="pdv && pdv.permissions.AMENA_CONVERGENTE === 'PERMITIR_ENVIO_AMENA_CONVERGENTE'">
                <button class="btn-black-outline btn-block mb-1 pt-3 pb-3" (click)="resumeOrderUser(order, 'amena/convergente')">Flujo convergente</button>
            </div>
            <div class="col-lg-6">
                <button class="btn-black-outline btn-block mb-1 pt-3 pb-3" (click)="resumeOrderUser(order, 'amena/solo_movil')">Flujo móvil</button>
            </div>
        </div>
    </div>
</ng-template>
